import { Dispatch } from "redux";
import { Actions } from "./";
import { IState, IDataEntityResponse, IAppParams } from "../models";
import { fetchFunds, fetchShareClassAndFund, fetchBenchmarks, fetchShareClasses } from "../data";
import * as constants from "./constants";
import { fetchFundLists } from "../utils/fundlist";

export function getFunds(options, appParams: IAppParams, isSearchPrimerCall = false, infiniteScrollOffset = 0) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let response: IDataEntityResponse;
        let responseAction: Actions;
        let state = getState();
        let { sorting } = state;

        if (isSearchPrimerCall) {
            dispatch({ type: constants.GET_TYPEAHEAD_START });
            responseAction = { type: constants.GET_TYPEAHEAD_END };
        }
        else if (infiniteScrollOffset > 0) {
            dispatch({ type: constants.INFINITE_SCROLL_START, payload: { offset: infiniteScrollOffset, loading: true } });
            responseAction = { type: constants.INFINITE_SCROLL_END };
        }
        else {
            dispatch({ type: constants.GET_FUNDS_START });
            responseAction = { type: constants.GET_FUNDS_END };
        }
        //response = await fetchFunds('fund_key', options, appParams, isSearchPrimerCall, sorting, infiniteScrollOffset, false,null);
		response = await fetchShareClasses(options, appParams);

        if (response.error) {
            responseAction["error"] = response.error;
        }
        else {
            responseAction["payload"] = response;
        }
        dispatch(responseAction);
    };
}

export function getShareClass(options: any, appParams: IAppParams) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let response: IDataEntityResponse;
		let responseAction: Actions;
		let state = getState();

		dispatch({ type: constants.GET_SHARE_CLASSES_START });
		responseAction = { type: constants.GET_SHARE_CLASSES_END };

		response = await fetchShareClasses(options, appParams);
		if (response.error) {
			responseAction["error"] = response.error;
		} else {
			responseAction["payload"] = response;
		}
		dispatch(responseAction);
	};
}

export function getShareClassAndFund(options, appParams: IAppParams, isCompare: boolean = false) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let state = getState();
        let { shareClass, loading } = state;
        let currentRequests = loading['currentRequests'] || [];
        if (!shareClass && currentRequests.indexOf('fund') === -1) {

            dispatch({ type: constants.GET_FUND_START });

            let response = await fetchShareClassAndFund('fund_key', options, appParams);
            let responseAction: Actions = { type: constants.GET_FUND_END };
            if (response.error) {
                responseAction["error"] = response.error;
            }
            else {
                responseAction["payload"] = response;
            }
            dispatch(responseAction);

            // load Benchmark/Sector Data in the background
            let benchmarkAction: Actions = { type: constants.GET_BENCHMARKS };
            let benchmarkResponse = await fetchBenchmarks();
            if (benchmarkResponse.error) {
                benchmarkAction.error = benchmarkResponse.error;
            }
            else {
                benchmarkAction.payload = benchmarkResponse.values;
            }
            dispatch(benchmarkAction);
        }

    };
}

export function toggleShareClassPerformance(shareClass, mustExpand = true) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let responseAction: Actions = {
            type: constants.TOGGLE_SHARE_CLASS_PERFORMANCE,
            payload: {
                shareClass,
                mustExpand
            }
        };
        dispatch(responseAction);
    };
}

export function toggleShareClass(shareClass, mustExpand = true) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let responseAction: Actions = {
            type: constants.TOGGLE_SHARE_CLASS,
            payload: {
                shareClass,
                mustExpand
            }
        };
        dispatch(responseAction);
    };
}

export function toggleFund(fund, mustExpand = true) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let responseAction: Actions = {
            type: constants.TOGGLE_FUND,
            payload: {
                fund,
                mustExpand
            }
        };
        dispatch(responseAction);
    };
}

export function toggleAllFunds(mustExpand = true) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let responseAction: Actions = {
            type: constants.TOGGLE_ALL_FUNDS,
            payload: {
                mustExpand
            }
        };
        dispatch(responseAction);
    };
}

export function changeSortOrder(sortOrder: "ASC" | "DESC" = "ASC", appParams: IAppParams) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {

        let responseAction: Actions = {
            type: constants.CHANGE_SORT_ORDER,
            payload: {
                sortOrder
            }
        };
        dispatch(responseAction);
        let state = getState();
        // await getFunds(state.filter, appParams)(dispatch, getState);
		await getShareClass(state.filter, appParams)(dispatch, getState);
    };
}
export function getSharePriceFundList() {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        const requestOptions = {
            listName: ['Share_Price_FundList'],
        };
        let SharePriceFundListResponse = await fetchFundLists(requestOptions);

        let responseAction: Actions = {
            type: constants.GET_SHARE_PRICE_FUNDLIST,
            payload: {
                SharePriceFundListResponse,
            }
        };

        dispatch(responseAction);
    };
}



// WEBPACK FOOTER //
// ./src/client/actions/entity.ts